<template>
	<div class="StockCalendar">
		<el-card class="box-card" style="overflow: visible;">
			<div >
				<div>
					<div class="header-section">
						<div>
							<div style="color: #e29d5a; font-weight: 600;">
								Stock Count Calendar
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="userDetails.access_level != 'outlet'"
					class="mt-4 input-box box-300"
				>
					<p class="input-label">Select Location</p>
					<el-select
						v-model="location"
						style="min-width: 100px;margin-top: 5px;text-transform: capitalize;"
						default-first-option
						filterable
						placeholder="Select Location"
						@change="getStockByLocation"
					>
						<el-option
							v-for="(outlet, outletIndex) in locations"
							:key="outletIndex"
							:value="outlet.id"
							:label="outlet.name"
							style="text-transform: capitalize;"
						/>
					</el-select>
				</div>
			</div>
		</el-card>

		<el-card class="box-card mt-5">
			<!-- <div
				class="text-sm font-semibold"
				style="display: flex; justify-content: flex-end; color: #e29d5a;"
			>
				Export to .csv
			</div> -->

			<simplebar class="simplebar mt-5">
				<table class="tableMain">
					<thead>
						<tr>
							<th>
								Category
							</th>
							<th>
								Select Method
							</th>
							<th>
								&nbsp;
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(category, index) in stockCalendar" :key="index">
							<td class="capitalize">
								<span class="active-link">
									{{ category.category_name }}
								</span>
							</td>
							<td>
								<el-select
									v-model="category.frequency"
									style="width: 50%;"
									size="mini"
									placeholder="select method"
									@change="changeFrequType(category.frequency, index)"
								>
									<el-option label="Daily" value="daily" />
									<el-option label="Weekly" value="weekly" />
									<el-option label="Fortnightly" value="fortnightly" />
									<el-option label="Monthly" value="monthly" />
									<el-option label="Quarterly" value="quarterly" />
									<el-option label="Yearly" value="yearly" />
								</el-select>
							</td>
							<td>
								<el-select
									v-if="category.frequency === 'weekly'"
									v-model="category.days"
									multiple
									collapse-tags
									size="mini"
									style="width: 80%;"
									placeholder="Days of Week"
								>
									<el-option
										v-for="(days, index1) in weeklyDropdownList"
										:key="index1"
										:label="days.label"
										:value="days.value"
									>
										{{ days.label }}
									</el-option>
								</el-select>

								<el-select
									v-if="category.frequency === 'monthly'"
									v-model="category.monthly"
									collapse-tags
									size="mini"
									style="width: 80%;"
									placeholder="Days of Month"
								>
									<el-option
										v-for="(item, index3) in monthlyDropdownList"
										:key="index3"
										:label="item.label"
										:value="item.value"
									/>
								</el-select>
							</td>
							<!-- <td>
								<el-select
									v-model="category.monthly"
									:disabled="
										category.frequency === 'daily' ||
											category.frequency === 'weekly'
									"
									collapse-tags
									style="width: 50%;"
									placeholder="Days of Month"
								>
									<el-option
										v-for="(item, index3) in 31"
										:key="index3"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td> -->
							<!-- <td>
								<BaseButton
									buttonclass="btn p-1 text-xs"
									@click="
										saveStockCalendarSchedule(category.frequency, { index })
									"
								>
									Save
								</BaseButton>
							</td> -->
						</tr>
					</tbody>
				</table>

				<div class="footer-section">
					<BaseButton
						class="mt-4 orng-btn"
						buttonclass="btn py-1.5 px-4 text-sm"
						@click="saveStockCalendarSchedule()"
					>
						Save
					</BaseButton>
				</div>
			</simplebar>

			<!-- <el-row>
				<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
					<div class="flex md:justify-end align-start md:flex-row flex-col">
						<div class="mt-4 text-right">
							<el-pagination
								background
								:current-page.sync="pageInfo.currentPage"
								:page-sizes="[5, 10, 15]"
								:page-size.sync="pageInfo.pageSize"
								layout="sizes, prev, pager, next"
								:total="pageInfo.totalCount"
								@size-change="handlePageInfoChange"
								@current-change="handlePageInfoChange"
							/>
						</div>
					</div>
				</el-col>
			</el-row> -->
		</el-card>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import InventoryService from "../../../../services/inventoryService";
import CommonService from "../../../../services/commonService";
import { Promise } from "q";
import { CommonMixin } from "../../../../../mixins/common.mixin";
import { resolve } from "q";
export default {
	name: "StockCalendar",
	components: {
		simplebar
	},
	mixins: [CommonMixin],
	data() {
		return {
			weeklyDropdownList: [
				{
					label: "Monday",
					value: 1
				},
				{
					label: "Tuesday",
					value: 2
				},
				{
					label: "Wednesday",
					value: 3
				},
				{
					label: "Thursday",
					value: 4
				},
				{
					label: "Friday",
					value: 5
				},
				{
					label: "Saturday",
					value: 6
				},
				{
					label: "Sunday",
					value: 7
				}
			],
			monthlyDropdownList: [
				{
					label: "Start of the Month",
					value: "start_of_the_month"
				},
				{
					label: "15th of the Month",
					value: "15th_of_the_month"
				},
				{
					label: "End of the Month",
					value: "end_of_the_month"
				}
			],
			stockCalendar: [],
			categories: [],
			outletId: "",
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 10,
				search: ""
			},
			locations: [],
			location: "",
			// addProductsArr: ["ket", "pet", "met"],
			userDetails: {}
		};
	},
	created() {
		this.getStockCountSchedule();

		// CommonService.getCategories({ fields: ["id", "name"] }).then(response => {
		// 	console.log(
		// 		"responsse in getCategories",
		// 		JSON.parse(response.data).results
		// 	);
		// 	this.categories = JSON.parse(response.data).results;
		// });
		this.getLocations().then(locations => {
			this.locations = locations.filter(el => el.type == "store" || el.type == "central_kitchen");
			this.location = this.locations[0].id;
			this.locations.sort((a, b) =>
				a.name > b.name ? 1 : b.name > a.name ? -1 : 0
			); // sort a-z store list
			if (this.location) {
				this.getStockByLocation();
			}
		});
		this.getUserSelf().then(userDetails => {
			this.userDetails = userDetails;
		});
	},
	methods: {
		getStockByLocation() {
			InventoryService.viewStockCountSchedule({
				outlet_id: this.location
			})
				.then(data => {
					this.stockCalendar = data.results;
					for (var i = 0; i < this.stockCalendar.length; i++) {
						this.$set(this.stockCalendar[i], "weekly", []);
						// this.$set(this.stockCalendar[i], "monthly", []);
						if (this.stockCalendar[i].frequency === "monthly") {
							console.log(this.stockCalendar[i].monthly);
							// this.stockCalendar[i].monthly = [
							// 	...this.stockCalendar[i].days
							// ].toString();
							// this.stockCalendar[i].monthly = this.stockCalendar[i].monthly;
						}
						if (this.stockCalendar[i].frequency === "weekly") {
							console.log(this.stockCalendar[i].frequency);
							this.stockCalendar[i].weekly = [
								...this.stockCalendar[i].days
							].toString();
						}
					}
					this.pageInfo.totalCount = data.count;
				})
				.catch(err => {
					let message;
					console.log(err);
					if (err === "no access_outlet") {
						message = "Please set outlet in user permissions";
					} else {
						message = "Something went wrong!";
					}
					this.$notify.error({
						title: "Fail",
						message: message,
						duration: 0
					});
				});
		},
		changeFrequType(frequency, index) {
			console.log(this.stockCalendar[index].days);
			if (frequency === "daily") {
				this.stockCalendar[index].monthly = null;
				this.stockCalendar[index].weekly = "";
			}
			if (frequency === "monthly") {
				// this.stockCalendar[index].monthly = this.stockCalendar[index].monthly;
				// this.stockCalendar[index].monthly = [
				// 	...this.stockCalendar[index].days
				// ].toString();
				this.stockCalendar[index].weekly = [];
				this.stockCalendar[index].days = [];
			}
			if (frequency === "weekly") {
				// this.stockCalendar[index].weekly = [
				// 	...this.stockCalendar[index].days
				// ].toString();
				this.stockCalendar[index].monthly = null;
			}
		},
		paginate() {
			return pageInfo => {
				InventoryService.viewStockCountSchedule({
					outlet_id: this.outletId,
					pageInfo
				}).then(data => {
					this.stockCalendar = data.results;
					this.pageInfo.totalCount = data.count;
				});
			};
		},
		async getUserSelf() {
			try {
				var userDetails = await CommonService.getLoggedinUserData().then(data =>
					resolve(data)
				);
			} catch (err) {
				console.log(err);
			}
			return userDetails;
		},
		async getLocations() {
			try {
				var locations = await CommonService.getAllOutlets({ get_all: true }).then(
					response => {
						return JSON.parse(response.data);
					}
				);
			} catch (err) {
				console.log(err);
			}
			return locations;
		},
		saveStockCalendarSchedule(frequency, { index = null } = {}) {
			if (index) {
				if (frequency === "weekly") {
					this.stockCalendar[index].monthly = null;
					// this.stockCalendar[index].days = [this.stockCalendar[index].weekly];
				} else if (frequency === "monthly") {
					// this.stockCalendar[index].days = [this.stockCalendar[index].monthly];
				} else if (frequency === "daily") {
					this.stockCalendar[index].days = [0];
					this.stockCalendar[index].monthly = null;
				}
			}
			for (var i = 0; i < this.stockCalendar.length; i++) {
				if (this.stockCalendar[i].frequency === "monthly") {
					// this.stockCalendar[i].days = [this.stockCalendar[i].monthly];
				} else if (this.stockCalendar[i].frequency === "weekly") {
					this.stockCalendar[i].monthly = null;
					// this.stockCalendar[i].days = [Number(this.stockCalendar[i].weekly)];
				} else {
					this.stockCalendar[i].monthly = null;
					this.stockCalendar[i].days = [0];
				}
			}
			InventoryService.saveStockCountSchedule({
				outlet_id: this.location,
				params: index ? [this.stockCalendar[index]] : this.stockCalendar
			})
				.then(response => {
					if (response.status === 201) {
						this.$notify.success({
							title: "Success",
							message: JSON.parse(response.data).message
						});
					} else {
						Promise.reject("error");
					}
				})
				.catch(err => {
					console.log(err);
					this.$notify.error({
						title: "Fail",
						message: "Something Went Wrong"
					});
				});
		},
		getStockCountSchedule() {
			CommonService.getLoggedinUserData()
				.then(data => {
					if (data) {
						this.outletId = data.access_outlet;
						return data;
					} else {
						return Promise.reject("no access_outlet");
					}
				})
				.then(accesOutlet => {
					if (accesOutlet.access_outlet) {
						InventoryService.viewStockCountSchedule({
							outlet_id: accesOutlet.access_outlet
						}).then(data => {
							this.stockCalendar = data.results;
							this.pageInfo.totalCount = data.count;
						});
					}
				})
				.catch(err => {
					let message;
					console.log(err);

					if (err === "no access_outlet") {
						message = "Please set outlet in user permissions";
					} else {
						message = "Something went wrong!";
					}
					this.$notify.error({
						title: "Fail",
						message: message,
						duration: 0
					});
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./StockCalendar.scss";
</style>

<style lang="scss">
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
</style>
